module.exports = function getResource(label, vars = []) {
    let resources = {
        weGotItHeader: 'Nous l’avons!',
        orderNumberText: 'Numéro de commande',
        pickupOrderNumberText: 'Numéro de la commande à ramasser',
        orderedMessageText: 'C’est commandé. Consultez votre boîte de réception d’ici peu pour voir le courriel de confirmation.',
        pickupOrderedMessageText: 'Vous recevrez un courriel de confirmation avec les détails de la réservation au',
        continueShoppingButton: 'Continuer à magasiner',
        cancelOrderButton: 'Annuler votre commande',
        estimatedDelivery: 'Livraison estimée',
        shipmentText: `Expédition ${vars[0]}`,
        viewBasketButton: 'Voir le panier',
        certonaTitle: 'Les gens ont aussi acheté',
        shipTo: 'Expédier à',
        pickupLocation: 'Lieu du ramassage',
        storeDetails: 'Détails du magasin',
        callStore: 'Appeler le magasin',
        seeFAQ: 'Voir la FAQ',
        contactInfo: 'Coordonnées',
        pickupBarcodeMsg: 'Montrez le code à barres de la commande à ramasser. Vous pouvez le trouver dans votre courriel ou en ouvrant cette page sur votre appareil mobile.',
        pickupPerson: 'Personne qui ramassera la commande',
        contactMessage1: 'Veuillez avoir en main votre ',
        confirmEmail: 'courriel de confirmation ',
        or: 'ou ',
        photoId: 'une pièce d’identité avec photo ',
        ready: 'au moment du ramassage de votre commande.'
    };

    return resources[label];
};
